import { render, staticRenderFns } from "./period.vue?vue&type=template&id=c0cf2e14&scoped=true"
import script from "./period.vue?vue&type=script&lang=js"
export * from "./period.vue?vue&type=script&lang=js"
import style0 from "./period.vue?vue&type=style&index=0&id=c0cf2e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cf2e14",
  null
  
)

export default component.exports